export const config = {
  apiLocation: process.env.EZIDEBIT_API_LOCATION,
  publicKey: process.env.EZIDEBIT_PUBLIC_KEY,
};



// WEBPACK FOOTER //
// ./lib/ezidebit/config.ts